import { c } from "node_modules/vite/dist/node/types.d-AKzkD8vd";
import { ReactNode } from "react";

export default function Index() {
  return (
    <div className="flex h-full w-full flex-col items-center bg-[#E3DACC]">
      <div className="text-bold mt-20 font-FKScreamer text-[48px] uppercase md:text-[100px]">
        Persónuverndarstefna
      </div>
      <div className="mx-6 mt-20 flex max-w-[600px] flex-col items-center text-center text-2xl font-semibold sm:mx-10">
        <Header>Nola ehf (www.nola.is)</Header>
        <Paragraph>
          Nola leggur mikið upp úr því að tryggja öryggi persónuupplýsinga
          viðskiptavina, starfsmanna og annarra sem félagið vinnur
          persónuupplýsingar um. Nola sér til þess að farið sé með allar
          persónuupplýsingar í samræmi við lög nr. 90/2018 um persónuvernd og
          vinnslu persónuupplýsinga. Stefna Nola er að geyma og vinna með eins
          lítið af persónugreinanlegum upplýsingum og mögulegt er til að geta
          veitt þá þjónustu sem félaginu ber að veita viðskiptavinum. Nola
          ábyrgist að nýta sér ekki upplýsingar um viðskiptavini á óábyrgan,
          óöruggan eða ólöglegan hátt. Allar upplýsingar sem viðskiptavinir Nola
          láta félaginu í té eða sem Nola sækir með þeirra leyfi til þriðja
          aðila eru eingöngu sóttar í þeim tilgangi að hægt sé að veita þeim þá
          þjónustu sem þeir eiga rétt á.
        </Paragraph>
        <Header>Tilgangur </Header>
        <Paragraph>
          Með persónuverndarstefnu þessari er gerð grein fyrir því hvernig Nola,
          stendur að söfnun, skráningu, vinnslu, vistun og miðlun
          persónugreinanlegra upplýsinga um viðskiptavini sína og einstaklinga
          sem heimsækja vefsíðu félagsins, www.Nola.is, hvort sem
          persónuupplýsingarnar eru geymdar rafrænt, á pappír eða með öðrum
          hætti.
        </Paragraph>
        <Header>Persónuupplýsingar sem Nola vinnur með</Header>
        <Paragraph>
          Nola vinnur með eftirfarandi persónuupplýsingar um alla viðskiptavini:
          Nafn, Netfang, heimilisfang & símanúmer. Nola vinnur
          persónuupplýsingar um tengiliði viðskiptavina og starfsmenn
          þjónustufyrirtækja sem veita Nola þjónustu. Einungis eru unnar
          upplýsingar um netföng og símanúmer í þeim tilgangi að auðvelda
          samskipti, gæta lögmætra hagsmuna félagsins og réttinda viðskiptavina.
          Til að eyða þinum gögnum þá getur þú haft samband við nola@nola.is.
        </Paragraph>
        <Header>Vafrakökur</Header>
        <Paragraph>
          Við heimsókn á vefsíðu Nola eru skráðar nauðsynlegar upplýsingar um
          aðgengi og notkun í þeim tilgangi að bæta upplifun notenda af
          þjónustunni, til dæmis með því að bæta hönnun þjónustunnar eða láta
          notendur vita af hugsanlegum tæknilegum vandamálum í búnaði þeirra.
          Þessar upplýsingar kunna að innihalda IP-tölur notanda. Þessi síða
          notar einnig vafrakökur fyrir nauðsynlega virkni og söfnun
          tölfræðiupplýsinga. Vafrakökur sem vefsíðan notar eru: _GID – Skráir
          einkvæmt auðkenni sem er notað til að búa til tölfræðileg gögn um
          heimsóknir gests á vefinn. (Gildistími: Lota (e. Session)) _GA –
          Skráir einkvæmt auðkenni sem er notað til að búa til tölfræðileg gögn
          um heimsóknir gests á vefinn. (Gildistími: 2 ár) Hægt er að slökkva á
          vafrakökum með því að fara í stillingar í þeim vafra sem notaður er
          til að heimsækja síðuna.
        </Paragraph>
        <Header>Varðveislutími og öryggi persónupplýsinga</Header>
        <Paragraph>
          Persónuupplýsingar eru varðveittar svo lengi sem þeirra er þörf til að
          ná þeim tilgangi sem söfnun þeirra fólst í, nema að lagaskylda hvíli á
          félaginu um að geyma þau lengur. Upplýsingar sem berast á tölvupósti
          til félagsins eru geymdar í 3 ár að jafnaði Bókhaldsskyld gögn eru
          geymd í 7 ár Upplýsingum um störf trúnaðarmanna á vinnustöðum er ekki
          eytt, það er upplýsingum um störf fyrir félagið og þau námskeið sem
          viðkomandi hefur sótt í tengslum við starf trúnaðarmanns. Það er gert
          til að tryggja að upplýsingar um námsferil viðkomandi séu aðgengilegar
          hefji hann aftur störf sem trúnaðarmaður síðar. Skilagreinum, þ.e.
          upplýsingum um iðgjaldagreiðslur, er ekki eytt þar sem nauðsynlegt er
          að varðveita þær svo félagið geti tryggt og staðfest réttindi
          viðskiptavina, bæði núverandi og fyrrum. Ef skráður einstaklingur
          hættir í félaginu er öðrum upplýsingum en þeim sem eru tilgreindar hér
          að ofan að jafnaði eytt eftir 6 mánuði. Nola gætir fyllsta öryggis við
          vinnslu persónuupplýsinga. Aðgangsstýringar eru viðhafðar til að
          takmarka aðengi að persónuupplýsingum og upplýsingar vistaðar á
          öruggan hátt hjá vinnsluaðilum félagsins. Sterk auðkenning er að á
          heimasvæði viðskiptavina, Mínar síður, og upplýsingum sem vistaðar eru
          þar er haldið í lágmarki.
        </Paragraph>

        <Header>Endurskoðun</Header>
        <Paragraph>
          Nola áskilur sér rétt til að breyta og uppfæra persónuverndarstefnu
          þessa hvenær sem er. Við látum vita af slíkum breytingum á heimasíðu
          Nola.
        </Paragraph>
      </div>
    </div>
  );
}

const Header = ({ children }: { children: ReactNode }) => (
  <div className="mb-4 mt-10 font-FKScreamer text-[48px] font-semibold leading-[48px]">
    {children}
  </div>
);
const Paragraph = ({ children }: { children: ReactNode }) => (
  <div className="my-2">{children}</div>
);
